import moment from "moment"
import _ from "lodash"

export default {
	displayName(nameObj) {
		if (!nameObj) {
			return "(Unknown)"
		}
		let parts = []
		if (nameObj.first) parts.push(nameObj.first)
		//if (nameObj.middle) parts.push(nameObj.middle)
		if (nameObj.last) parts.push(nameObj.last)
		return parts.join(" ")
	},

	displayNameReverse(nameObj) {
		if (!nameObj) {
			return "(Unknown)"
		}
		let parts = []
		if (nameObj.first) parts.push(nameObj.first)
		if (nameObj.middle) parts.push(nameObj.middle)
		let suffix = parts.join(" ")

		if (nameObj.last) {
			return `${nameObj.last}, ${suffix}`
		} else {
			return suffix
		}
	},

	sortByName(list) {
		return _.sortBy(list, ["name.last", "name.first"])
	},

	roleName(role) {
		switch (role) {
			case "ADMIN":
				return "Administrator"
			case "TEACHER":
				return "Teacher"
			case "PARTNER":
				return "Community Partner"
			case "STUDENT":
				return "Student"
			case "JUDGE":
				return "Judge"
			default:
				return "[Unknown]"
		}
	},

	roleIcon(role) {
		switch (role) {
			case "ADMIN":
				return "fa-shield"
			case "TEACHER":
				return "fa-user-graduate"
			case "PARTNER":
				return "fa-users"
			case "STUDENT":
				return "fa-user"
			case "JUDGE":
				return "fa-gavel"
			default:
				return "[Unknown]"
		}
	},

	roleOptions: [
		{ name: "Admin", id: "ADMIN", sequence: 0 },
		{ name: "Teacher", id: "TEACHER", sequence: 1 },
		{ name: "Partner", id: "PARTNER", sequence: 2 },
		{ name: "Student", id: "STUDENT", sequence: 3 },
		{ name: "Judge", id: "JUDGE", sequence: 4 },
	],

	dateString(date) {
		return moment(date).format("LL");
	},

	fullDate(date) {
		return moment(date).format("l LTS");
	},

	medDate(date) {
		return moment(date).format("l LT");
	},

	shortDate(date) {
		return moment(date).format("l");
	},

	miniDate(date) {
		return moment(date).format("MMM D")
	},

	sinceString(date) {
		return moment(date).fromNow();
	},

	round1d(num) {
		return Math.round(num * 10) / 10
	},

	listNames(array) {
		let els = []
		_.each(array, a => {
			els.push(this.displayName(a.name))
		})

		return els.join(", ")
	},

	withinWindow(start, end) {
		let current = moment()
		let startTime = moment(start).startOf("day")
		let endTime = moment(end).endOf("day")
		return current.isAfter(startTime) && current.isBefore(endTime)
	},

	timeFormat: "h:mm A",
	dateFormat: "MMMM DD, YYYY",
	timeConfig: {
		format: "h:mm A",
		icons: {
			time: "fa fa-clock-o",
			date: "fa fa-calendar",
			up: "fa fa-chevron-up",
			down: "fa fa-chevron-down",
			previous: "fa fa-chevron-left",
			next: "fa fa-chevron-right",
			today: "fa fa-sun-o",
			clear: "fa fa-trash",
			close: "fa fa-remove"
		}
	},
	dateConfig: {
		format: "MMMM DD, YYYY",
		inline: true,
		viewMode: "days",
		icons: {
			time: "fa fa-clock-o",
			date: "fa fa-calendar",
			up: "fa fa-chevron-up",
			down: "fa fa-chevron-down",
			previous: "fa fa-chevron-left",
			next: "fa fa-chevron-right",
			today: "fa fa-sun-o",
			clear: "fa fa-trash",
			close: "fa fa-remove"
		}
	},

	sortByDate(list, field) {
		let sorted = _.sortBy(list, el => {
			if (!el[field]) {
				return 0
			}

			let date = new Date(el[field])
			return date.valueOf()
		})
		return sorted
	},

	profileQuestions: [
		{ id: "101", text: "I am good at presenting ideas in front of an audience." },
		{ id: "102", text: "I am comfortable taking charge in a group to move a project forward." },
		{ id: "103", text: "I invent solutions to problems." },
		{ id: "104", text: "I accomplish even the toughest goals and challenges -- I do not give up." },
		{ id: "105", text: "I think collaborating with a diverse group of people is the best way to achieve a sustainable solution to a problem." },
		{ id: "106", text: "I have lots of creative ideas." },
		{ id: "107", text: "My current talents and strengths are valuable to solving any problem my team will address." },
		{ id: "108", text: "I do not need much direction when trying to accomplish a goal or task." },
		{ id: "109", text: "I understand professional behaviors that will be expected of me in a workplace." },
		{ id: "110", text: "I understand the resources needed to launch a new product." },
		{ id: "111", text: "I analyze and evaluate data to find solutions to complex problems." },
		{ id: "112", text: "I adjust quickly when in new and unexpected situations." },
		{ id: "113", text: "I enjoy learning new things." },
		{ id: "114", text: "I don't mind failing, it gets me closer to a solution." },
		{ id: "115", text: "I know how to get my innovative ideas accepted by others." },
		{ id: "116", text: "I have skills to succeed in a STEM career (science, technology, engineering, mathemetics)." },
		{ id: "117", text: "I would enjoy working in a business that focuses on STEM (science, technology, engineering, mathemetics)." }
	],

	mockAPIResponse(response) {
		return new Promise((resolve) => {
			resolve({ data: response })
		})
	},

	statistics(scores) {
		if (!scores || scores.length == 0) {
			return [0, 0, 0]
		}

		scores.sort((a, b) => { return a - b })
		let rangeLow = scores[0]
		let rangeHigh = scores[scores.length - 1]
		let count = scores.length
		let midpoint = Math.floor(scores.length / 2)
		let median = count % 2 == 0 ? (scores[midpoint - 1] + scores[midpoint]) / 2 : scores[midpoint]

		let freqs = {}
		let total = 0
		for (let score of scores) {
			if (!freqs[score]) {
				freqs[score] = 0
			}
			freqs[score]++
			total += score
		}
		let mean = total / count

		let highestFreq = 0
		_.each(freqs, (freq) => {
			highestFreq = Math.max(highestFreq, freq)
		})
		let modes = []
		_.each(freqs, (freq, score) => {
			if (freq == highestFreq) {
				modes.push(this.round1d(score))
			}
		})

		let mode = modes.join(", ")

		return [mean, median, mode, rangeLow, rangeHigh]
	},

	pitchScoreDescription(score) {
		if (score < 0 || score > 100 || isNaN(score)) {
			return "(Unknown)"
		} else if (score >= 0 && score < 10) {
			return "Not covered"
		} else if (score >= 10 && score < 40) {
			return "Lacking details"
		} else if (score >= 40 && score < 60) {
			return "Sufficiently covered in some parts but not others"
		} else if (score >= 60 && score < 90) {
			return "Covered with sufficient detail"
		} else if (score >= 90 && score <= 100) {
			return "Covered with exemplary details"
		}
	},

	profileScoreDescription(score) {
		if (score < 0 || score > 100 || isNaN(score)) {
			return "(Unknown)"
		} else if (score >= 0 && score < 10) {
			return 'Not at all like me'
		} else if (score >= 10 && score < 30) {
			return 'Not much like me'
		} else if (score >= 30 && score < 50) {
			return 'Somewhat unlike me'
		} else if (score >= 50 && score < 70) {
			return 'Somewhat like me'
		} else if (score >= 70 && score < 90) {
			return 'Much like me'
		} else if (score >= 90 && score <= 100) {
			return 'Very much like me'
		}
	},

	isAllNull(list) {
		for (let el of list) {
			if (el != null) {
				return false
			}
		}
		return true
	},

	namesListTooltip(title, list) {
		let tooltip = `<div class="text-left ml-4 mt-3">${title}:</div>
		<ul class="text-left mt-3 mr-3">`;
		_.each(list, el => {
			tooltip += `<li>${el.name}</li>`;
		});
		tooltip += "</ul>";
		return tooltip;
	},

	constructSliderMarks(marks) {
		if (!(marks && marks.length > 0)) return []

		let collapsedMarks = []
		let definedTicks = {}
		let min = marks[0].tick
		let max = marks[0].tick

		_.each(marks, mark => {
			if (mark.type == 0) {
				collapsedMarks.push(mark.tick)
				definedTicks[mark.tick] = true
				min = Math.min(min, mark.tick)
				max = Math.max(max, mark.tick)
			}
			if (mark.type == 1) {
				collapsedMarks.push({'label': mark.label, 'description': mark.description})
			}
		})

		// Add additional marks at intervals of 10 or 5 to fill in the slider
		if (min % 10 == 0 && max % 10 == 0) {
			for (let i = min; i < max; i += 10) {
				if (!definedTicks[i]) {
					collapsedMarks.push(i)
				}
			}
		} else if (min % 5 == 0 && max % 5 == 0) {
			for (let i = min; i < max; i += 5) {
				if (!definedTicks[i]) {
					collapsedMarks.push(i)
				}
			}
		}

		return collapsedMarks
	}
}
